import styled from 'styled-components';

const ExploreSuccessStories = styled.div`
    background: #f9f9f9;
    padding: 60px 0 48px 0;
    @media (max-width: 767px) {
        padding: 48px 0 48px 0;
    }
    .grid-col {
        grid-gap: 24px;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        display: grid;
        @media (max-width: 1040px) {
            grid-template-columns: 1fr 1fr 1fr;
            @media (max-width: 991px) {
                grid-template-columns: 1fr 1fr;
                @media (max-width: 767px) {
                    grid-template-columns: 1fr;
                }
            }
        }
    }
    .card-action {
        width: 100%;
        border-radius: 8px;
        box-shadow:0px 0px 0px 1px rgba(0, 0, 0, 0.10) inset;
    }

    .card-heading {
        height: 52px;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: -o-ellipsis-lastline;
        @media (max-width: 991px) {
            height: 46px;
        }
    }
    .card-desc {
        -webkit-box-orient: vertical;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: -o-ellipsis-lastline;
        height: 24px;
        p{
            margin:0 !important;
        }
    }
    .load-more {
        margin-top: 48px;
        padding-top: 32px;
        width: 100%;
        border-top: #e5e5e5 solid 1px;
        @media (max-width: 767px) {
            display: none;
        }
    }
    .MuiTypography-headline-medium {
        padding-right: 85px;
        margin-bottom: 15px;
    }
`;
export default ExploreSuccessStories;
